import {
  useClassificationRulesPanel,
  ClassificationRulesPanelHeader,
  ClassificationRulesTable,
  ClassificationRuleCreateDialog,
  ClassificationRuleEditDialog,
  ClassificationRuleDeleteDialog,
} from "../classification-rules";

export function CoreSignalConfigurationPanel() {
  const {
    rules,
    isLoading,
    sortField,
    sortDirection,
    isCreateDialogOpen,
    editingRule,
    deletingRule,
    handleSort,
    handleCreate,
    handleUpdate,
    handleDelete,
    setIsCreateDialogOpen,
    setEditingRule,
    setDeletingRule,
    createIsLoading,
    updateIsLoading,
    deleteIsLoading,
    rulesCount,
  } = useClassificationRulesPanel();

  return (
    <div className="w-full space-y-6">
      <ClassificationRulesPanelHeader
        rulesCount={rulesCount}
        onCreateClick={() => setIsCreateDialogOpen(true)}
      />

      <div className="rounded-xl border border-grid-200 bg-white shadow-sm">
        {isLoading ? (
          <div className="py-12 text-center text-sm text-ink-500">
            Loading classification rules...
          </div>
        ) : (
          <ClassificationRulesTable
            rules={rules}
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={handleSort}
            onEdit={(rule) => setEditingRule(rule)}
            onDelete={(rule) => setDeletingRule(rule)}
          />
        )}
      </div>

      <ClassificationRuleCreateDialog
        open={isCreateDialogOpen}
        isLoading={createIsLoading}
        onOpenChange={setIsCreateDialogOpen}
        onSubmit={handleCreate}
      />

      <ClassificationRuleEditDialog
        open={!!editingRule}
        rule={editingRule}
        isLoading={updateIsLoading}
        onOpenChange={(open) => !open && setEditingRule(null)}
        onSubmit={handleUpdate}
      />

      <ClassificationRuleDeleteDialog
        open={!!deletingRule}
        rule={deletingRule}
        isLoading={deleteIsLoading}
        onOpenChange={(open) => !open && setDeletingRule(null)}
        onConfirm={handleDelete}
      />
    </div>
  );
}
